/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BubbleMenu } from '@tiptap/react';
import down from '../../../../../assets/images/icondropdown.svg';

const BrandBubbleMenu = ({ editor, appendTo }) => {
    const [editAttributes, setEditAttributes] = useState({
        isPopular: false,
        isLatest: true,
        brandCount: 10,
    });

    const [openDropdown, setOpenDropdown] = useState(false);
    const [countError, setCountError] = useState('');

    const dropdownRef = useRef(null);

    const getNodeAttrs = useCallback(() => {
        const nodeAttrs = editor.state.selection.node?.attrs;
        if (nodeAttrs) {
            setEditAttributes({
                isPopular: nodeAttrs.isPopular,
                isLatest: nodeAttrs.isLatest,
                brandCount: nodeAttrs.brandCount || 10,
            });
        }
    }, [editor]);

    const shouldShow = useCallback(() => {
        if (editor.isActive('brand')) {
            getNodeAttrs();
        }
        return editor.isActive('brand') && editor.isFocused;
    }, [editor]);

    const handleApplyChange = () => {
        editor.chain().focus().updateAttributes('brand', editAttributes).run();
    };

    const handleBrandTypeChange = (type) => {
        setEditAttributes((prev) => ({
            ...prev,
            isPopular: type === 'isPopular',
            isLatest: type === 'isLatest',
        }));

        setOpenDropdown(false); // optional: close dropdown after select
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedLabel = editAttributes.isPopular
        ? 'Popular Brand'
        : editAttributes.isLatest
            ? 'Latest Brand'
            : 'Brand Type';

    return (
        <BubbleMenu
            editor={editor}
            shouldShow={shouldShow}
            updateDelay={0}
            tippyOptions={{
                zIndex: 99,
                popperOptions: { modifiers: [{ name: 'flip', enabled: false }] },
                appendTo: () => appendTo?.current,
            }}
        >
            <div className="bubble-toggle-menu button-box image-bubble-menu brand">
                <div className="brand-bubble-block">
                    <div
                        className="dropdown-wrapper order-status-dropdown"
                        ref={dropdownRef}
                    >
                        <div
                            className="dropdown-header"
                            onClick={() => setOpenDropdown(!openDropdown)}
                        >
                            <span className="title">{selectedLabel}</span>
                            <span className={`arrow ${openDropdown ? 'rotate' : ''}`}>
                                <img src={down} alt="arrow" />
                            </span>
                        </div>

                        {openDropdown && (
                            <div className="dropdown-list">

                                <label
                                    className={`dropdown-item ${editAttributes.isPopular ? 'active' : ''}`}
                                    onClick={() => handleBrandTypeChange('isPopular')}
                                >
                                    <span>Popular Brand</span>
                                </label>

                                <label
                                    className={`dropdown-item ${editAttributes.isLatest ? 'active' : ''}`}
                                    onClick={() => handleBrandTypeChange('isLatest')}
                                >
                                    <span>Latest Brand</span>
                                </label>
                            </div>
                        )}

                    </div>
                    <label className="text-box">
                        Brand Count
                        <input
                            type="text"
                            placeholder="Brand Count"
                            value={editAttributes.brandCount}
                            onChange={(e) => {
                                const value = e.target.value;

                                // Allow only digits
                                if (!/^\d*$/.test(value)) return;

                                let error = '';
                                if (Number(value) < 0) {
                                    error = 'Minimum brand count is 1';
                                }

                                setEditAttributes((prev) => ({
                                    ...prev,
                                    brandCount: value,
                                }));

                                setCountError(error);
                            }}
                        />
                    </label>
                    {countError && <div className="error-message">{countError}</div>}
                    <div className="button-element publication-submit-button">
                        <button onClick={handleApplyChange}>Apply</button>
                    </div>
                </div>
            </div>
        </BubbleMenu>
    );
};

export default BrandBubbleMenu;